<template>
  <div class="space-y-3" data-testid="project-settings-notifications">
    <div
      v-for="trigger in triggers"
      :key="trigger.id"
      class="p-4 border border-[#E5E5E5] rounded-[10px]"
    >
      <div class="flex items-start justify-between gap-3">
        <div class="flex-1 min-w-0">
          <p class="text-[14px] font-medium m-0 text-[var(--color-dark,#1A1A1A)]">
            {{ $t(`UserProjects.settings.notifications.${trigger.id}.label`) }}
          </p>
          <p class="text-[12px] text-[#6B6B6B] mt-0.5 m-0">
            {{ $t('UserProjects.settings.notifications.notifies', {
              recipients: $t(`UserProjects.settings.notifications.${trigger.id}.recipients`),
            }) }}
          </p>
          <p class="text-[12px] text-[#6B6B6B] m-0">
            {{ $t('UserProjects.settings.notifications.channel') }}
          </p>
        </div>
        <ToggleSwitch
          class="shrink-0 mt-0.5"
          :model-value="!!modelValue[trigger.id]"
          :disabled="!canManage"
          :ariaLabel="$t(`UserProjects.settings.notifications.${trigger.id}.label`)"
          :pt="{ root: { 'data-testid': `project-settings-notif-${trigger.id}` } }"
          @update:model-value="(value) => patch({ [trigger.id]: value })"
        />
      </div>
      <div
        v-if="trigger.id === 'behavior_pattern' && modelValue.behavior_pattern"
        class="flex items-center gap-2 mt-3 pt-3 border-t border-[#F0F0F0] flex-wrap"
      >
        <span class="text-[12px] text-[#6B6B6B]">
          {{ $t('UserProjects.settings.notifications.threshold') }}
        </span>
        <input
          type="number"
          min="1"
          max="20"
          class="ps-notif-input"
          :value="modelValue.behaviorPatternThreshold"
          :disabled="!canManage"
          data-testid="project-settings-notif-threshold"
          @input="patch({ behaviorPatternThreshold: clampInt($event.target.value, 1, 20) })"
        >
        <span class="text-[12px] text-[#6B6B6B]">
          {{ $t('UserProjects.settings.notifications.inWeeks') }}
        </span>
        <input
          type="number"
          min="1"
          max="12"
          class="ps-notif-input"
          :value="modelValue.behaviorPatternWeeks"
          :disabled="!canManage"
          data-testid="project-settings-notif-weeks"
          @input="patch({ behaviorPatternWeeks: clampInt($event.target.value, 1, 12) })"
        >
        <span class="text-[12px] text-[#6B6B6B]">
          {{ $t('UserProjects.settings.notifications.weeks') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleSwitch from 'primevue/toggleswitch';

const TRIGGERS = [
  'ppc_threshold',
  'commitment_deadline',
  'user_inactive',
  'tbi_threshold',
  'weekly_reminder',
  'behavior_pattern',
];

export default {
  name: 'ProjectSettingsNotificationsTab',
  components: { ToggleSwitch },
  props: {
    modelValue: { type: Object, required: true },
    canManage: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  computed: {
    triggers() {
      return TRIGGERS.map((id) => ({ id }));
    },
  },
  methods: {
    patch(partial) {
      this.$emit('update:modelValue', { ...this.modelValue, ...partial });
    },
    clampInt(raw, min, max) {
      const value = parseInt(raw, 10) || min;
      return Math.min(max, Math.max(min, value));
    },
  },
};
</script>

<style scoped>
.ps-notif-input {
  width: 3.5rem;
  height: 2rem;
  padding: 0 0.5rem;
  border: 1.5px solid #e5e5e5;
  border-radius: 8px;
  background: #fff;
  color: var(--color-dark, #1a1a1a);
  font-size: 13px;
  text-align: center;
  box-shadow: none;
}

.ps-notif-input:focus {
  outline: none;
  border-color: var(--color-orange, #e4821a);
  box-shadow: 0 0 0 2px rgba(228, 130, 26, 0.2);
}

.ps-notif-input:disabled {
  opacity: 0.7;
  cursor: default;
}
</style>
